import { useSeo } from "@/lib/seo";
import { IMAGES } from "@/data/site";
import PageHero from "@/components/PageHero";
import { Reveal, Overline } from "@/components/Reveal";

const BENEFITS = [
  "Infrastructure improvements", "Workforce housing", "Utility modernization", "Employment",
  "Education", "Local economic development", "Community facilities", "Heat reuse",
  "Energy efficiency", "Water and wastewater improvements",
];

export default function Community() {
  useSeo("Community Development | 12 Stone Development Group",
    "Growth should create value beyond the property line. 12 Stone develops with community infrastructure, workforce housing, utility modernization and local economic development in mind.");
  return (
    <div>
      <PageHero overline="Community Development" title="Growth Should Create Value Beyond the Property Line"
        subtitle="Well-structured development can strengthen the communities that host it — through infrastructure, jobs, housing and modernized utilities."
        image={IMAGES.aerialLand} />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-20">
        <Reveal>
          <p className="text-lg text-foreground/90 leading-relaxed">
            12 Stone approaches development as a long-term relationship with a place. When land, power and
            infrastructure come together responsibly, the surrounding community can benefit well beyond a single
            project's boundaries.
          </p>
          <p className="mt-5 text-sm text-muted-foreground italic">
            We do not make unverified promises. Potential community benefits may include the items below, and projects
            may be structured to support them depending on scope, partners and local priorities.
          </p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-24">
        <Reveal><Overline>Potential Community Benefits May Include</Overline></Reveal>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {BENEFITS.map((b, i) => (
            <Reveal key={b} delay={(i % 3) * 0.05}>
              <div className="rounded-xl border border-border bg-card p-6">
                <div className="font-mono text-xs text-primary mb-2">{String(i + 1).padStart(2, "0")}</div>
                <div className="text-foreground font-medium">{b}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
